import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import times from "lodash/times";
import { StyledStarsComponent } from "./stars-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
class StarsComponent extends PureComponent {
    renderStars() {
        const { numberOfSelectedStars, starsCount } = this.props;
        const numberOfSelectedStarsAsInt = parseInt(numberOfSelectedStars);
        const starsCountAsInt = parseInt(starsCount);
        return times(starsCountAsInt, (index)=>{
            const isSelected = numberOfSelectedStarsAsInt > index;
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("star-icon-wrapper", {
                    selected: isSelected
                }),
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: "/static/img/star.png"
                })
            }, index);
        });
    }
    render() {
        const { paddingTop } = this.props;
        return /*#__PURE__*/ _jsx(StyledStarsComponent, {
            className: "stars-component",
            style: {
                paddingTop
            },
            children: this.renderStars()
        });
    }
}
export { StarsComponent as default };
StarsComponent.defaultProps = {
    paddingTop: 0,
    numberOfSelectedStars: "5",
    starsCount: "5"
};
